import React from 'react';

import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';

import { REQUEST_TYPE_OPTIONS } from './constants';
import type { Filters } from './types';

interface FilterToolbarProps {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  showRequestTypeFilter: boolean;
  showStatusFilter: boolean;
  onSearch: () => void;
  onClear: () => void;
}

export default function FilterToolbar({
  filters,
  setFilters,
  showRequestTypeFilter,
  showStatusFilter,
  onSearch,
  onClear,
}: FilterToolbarProps) {
  return (
    <Stack direction="row" spacing={1.5} flexWrap="wrap" alignItems="flex-end" mb={2}>
      <TextField
        size="small"
        label="Partner ID"
        value={filters.vendor_id}
        onChange={(e) => setFilters((f) => ({ ...f, vendor_id: e.target.value }))}
        sx={{ width: 180 }}
      />
      <TextField
        size="small"
        label="Property ID"
        value={filters.property_id}
        onChange={(e) => setFilters((f) => ({ ...f, property_id: e.target.value }))}
        sx={{ width: 160 }}
      />
      {showRequestTypeFilter && (
        <FormControl size="small" sx={{ minWidth: 210 }}>
          <InputLabel id="extranet-approval-request-type-filter-label">Change type</InputLabel>
          <Select
            labelId="extranet-approval-request-type-filter-label"
            id="extranet-approval-request-type-filter"
            label="Change type"
            value={filters.request_type}
            onChange={(e) => setFilters((f) => ({ ...f, request_type: e.target.value }))}
            inputProps={{ 'data-testid': 'extranet-approval-request-type-filter-input' }}
          >
            <MenuItem value="">All change types</MenuItem>
            {REQUEST_TYPE_OPTIONS.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {showStatusFilter && (
        <FormControl size="small" sx={{ minWidth: 130 }}>
          <InputLabel id="extranet-approval-status-filter-label">Status</InputLabel>
          <Select
            labelId="extranet-approval-status-filter-label"
            id="extranet-approval-status-filter"
            label="Status"
            value={filters.status}
            onChange={(e) => setFilters((f) => ({ ...f, status: e.target.value }))}
            inputProps={{ 'data-testid': 'extranet-approval-status-filter-input' }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="approved">Approved</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
            <MenuItem value="superseded">Superseded</MenuItem>
          </Select>
        </FormControl>
      )}
      <Stack direction="row" spacing={1}>
        <Button variant="contained" onClick={onSearch}>
          Search
        </Button>
        <Button variant="text" onClick={onClear}>
          Clear
        </Button>
      </Stack>
    </Stack>
  );
}
